import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { colors } from '@guryou/colors';
import { Avatar, Block, FlexColumn, generateImageUrl, LargeText, Modal, openModal, SmallGrayText } from '@guryou/html-components';
import UserImageForm from './UserImageForm';

const UserImage = ({ acc }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <div class="flex items-center mb-4">
      <img src={generateImageUrl(acc.image)} alt="User avatar" class="h-16 w-16 rounded-full mr-4 object-cover object-center" />
      <button class={` text-white px-4 py-2 rounded-lg bg-[${colors.mandy}]`} onClick={() => dispatch(openModal('changeAvatar'))}>
        Upload
      </button>
      <Modal id="changeAvatar" title={t('GENERAL.changeAvatar')}>
        <UserImageForm />
      </Modal>
    </div>
  );
};

export default UserImage;
